import { render, staticRenderFns } from "./Nomination_Info.vue?vue&type=template&id=b93febfe&scoped=true&"
import script from "./Nomination_Info.vue?vue&type=script&lang=js&"
export * from "./Nomination_Info.vue?vue&type=script&lang=js&"
import style0 from "./Nomination_Info.vue?vue&type=style&index=0&id=b93febfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93febfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VForm,VTextField})
